import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";

export interface DeleteModalCommonProps {
  cancelEvent: () => void;
  closeEvent?: () => void;
}

interface CommentDeleteModalProps extends DeleteModalCommonProps {
  commentId?: string;
}

export default function CommentDeleteModal({
  cancelEvent,
  commentId,
  closeEvent,
}: CommentDeleteModalProps) {
  const [deleteBtnClick, setDeleteBtnClick] = useState(false);
  const [reason, setReason] = useState("");

  // 코멘트 삭제
  const { response, loading } = useApi({
    method: "delete",
    url: deleteBtnClick ? `comment/${commentId}` : undefined,
    data: {
      reason,
    },
  });

  console.log(response);

  useEffect(() => {
    if (response?.status === 200) {
      if (closeEvent) {
        closeEvent();
      }
      toast.success("코멘트가 삭제되었습니다.", {});
    }
  }, [closeEvent, response]);

  return (
    <DefaultModalLayout
      modalTitle="코멘트 삭제"
      isDeleteModal={true}
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setDeleteBtnClick(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>삭제 사유</DeleteModalLabel>

      <Textarea
        placeholder="삭제 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}

export const DeleteModalLabel = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
  color: #858c97;
  margin-bottom: 12px;
`;
